import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const routes = [
    {
        path: '/',
        name: 'Home',
        beforeEnter() {
            window.location.href = 'https://institucional.jmjsistemas.com.br/'; // URL para onde quer redirecionar
        }
    },
    {
        path: '/suemg',
        name: 'SUEMG',
        component: () => import('@/pages/ContatoView.vue'),
        props: { showMenu: false, origem: 'SUEMG' },
    },
    {
      path: '/porlgpd',
      name: 'PORLGPD',
        beforeEnter() {
            window.location.href = 'https://institucional.jmjsistemas.com.br/lgpd'; // URL para onde quer redirecionar
        }
    }
];

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior (to) {
      const scroll = {}
      if (to.meta.toTop) scroll.top = 0
      if (to.meta.smoothScroll) scroll.behavior = 'smooth'
      return scroll
    }
  })

export default router